import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import config from 'config';
import Icon from 'common/icon';

const AmountCard = ({ onSelect, amount, estimate, tier, isSelected, isDeselected }) => (
    <div>
        <button
            type="button"
            onClick={onSelect}
            className={cx(
                'bg-white shadow block w-full flex items-stretch mx-auto transition focus:outline-none hover:opacity-100 border-2',
                {
                    'shadow-lg': isSelected,
                    'opacity-40': isDeselected,
                }
            )}
            css={{
                minHeight: 90,
                maxWidth: 200,
                borderColor: isSelected
                    ? config(`/tailwind/colors/${tier || 'gray-20'}`)
                    : config('/tailwind/colors/white'),
            }}
            data-testid="amount-preset"
        >
            {tier && (
                <div
                    className="flex-no-shrink w-14 flex flex-col justify-center items-center"
                    css={{
                        backgroundColor: config(`/tailwind/colors/${tier}`),
                        margin: '-2px 0 -2px -2px',
                    }}
                >
                    {tier === 'diamond' ? (
                        <Icon icon="gem" className="text-black-20 text-24" />
                    ) : (
                        <Icon icon="trophy" type="solid" className="text-black-20 text-24" />
                    )}
                </div>
            )}
            <div className="py-8 md:py-10 xxxl:py-12 px-4 flex-grow">
                <p className="text-21 md:text-24 font-black text-gray-90">{amount}</p>
                {tier && (
                    <p
                        className="text-12 capitalize font-medium mt-2"
                        css={{ color: config(`/tailwind/colors/${tier}`) }}
                    >
                        {tier} Tier
                    </p>
                )}
            </div>
        </button>
        {estimate && (
            <p className="text-11 text-gray-40 font-medium text-center mt-6">
                Estimated total: <span className="text-gray-70">{estimate}</span>
            </p>
        )}
    </div>
);

AmountCard.propTypes = {
    onSelect: PropTypes.func.isRequired,
    amount: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    isDeselected: PropTypes.bool,
    estimate: PropTypes.string,
    tier: PropTypes.oneOf(['diamond', 'gold', 'silver', 'bronze']),
};

AmountCard.defaultProps = {
    isSelected: false,
    isDeselected: false,
    estimate: null,
    tier: null,
};

export default AmountCard;
